<template>
    <div class="map" :style="{height:`${ClientHeight}px` }">
        <div class="map_header">
            <div class="left">
                <span class="iconfont icon-ditu1"></span>
                <span>党建地图</span>
                <el-select v-model="deptId" placeholder="请选择组织" @change="deptChange" style="margin-left:20px;">
                    <el-option
                    
                    v-for="item in AllDeptList"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId">
                    </el-option>
                </el-select>
            </div>
            <div class="right">
                <el-button>
                    <router-link to="/" style="color:#000">返回首页</router-link>
                </el-button>
                <el-button>
                    <router-link to="/login" style="color:#000">登录</router-link>
                </el-button>
            </div>
        </div>

        <div class="mark_info" :style="{left: `${ClientLeft}px`,top:`${ClientTop}px`}">

        </div>

        <div id="container" :style="{height:`${ClientHeight}px` }"></div>

      

    </div>
</template>

<script>
    export default {
        data() {
            return {
                ClientHeight: "",
                map: "", // 地图实例
                markerIcon: require("../../assets/static/index/mark_map.png"),
                ClientLeft: 0,
                ClientTop: 0,
                infoWindow: "",
                MainPointX:113.682624,
                MainPointY: 34.791256,
                DeptList: [], // 组织列表
                deptId: "", // 组织ID
                AllDeptList: [],
                activeIndex: null,
            }
        },
        mounted () {
            this.getClientHeight()
            this.getMapPoint()
            this.InitMap();
        },
        methods: {
            // 初始化地图
            InitMap () {
                         // 创建地图实例 
                         let px = "", py = ""
                if ( this.DeptList.length ) {
                    px = this.DeptList[0].lng
                    py = this.DeptList[0].lat
                } else {
                    px = this.MainPointX
                    py = this.MainPointY
                }
                this.map = new BMapGL.Map("container"); 
                var point = new BMapGL.Point(px, py);  // 创建点坐标 
                this.map.centerAndZoom(point, 15);  
                this.map.enableScrollWheelZoom(true); 
                console.log("init")
                this.addMapMark()
            },
            // 想地图添加mark point
            addMapMark () {

                if ( this.DeptList && this.DeptList.length ) {
                    this.DeptList.forEach( el => {
                        if ( el.lat && el.lng ) {
                            var point = new BMapGL.Point( el.lng, el.lat); 
                            var myIcon = new BMapGL.Icon(this.markerIcon, new BMapGL.Size(30, 40), {   
                                anchor: new BMapGL.Size(10, -3),   
                            });     
                                // 创建标注对象并添加到地图  
                            var marker = new BMapGL.Marker(point, {icon: myIcon});  
                            marker.addEventListener("click", () => { this.clickMark( el ) } ); 
                            this.map.addOverlay(marker); 
                        }
                        
                    })
                }
                

            },
            // 获取视图高度
            getClientHeight () {
                this.ClientHeight = document.documentElement.clientHeight
                // console.log( height )
            },
            // 点击mark时记录鼠标位置
            async clickMark ( e ) {
                console.log( e )
                let self = this 
                await this.getDeptInfo( e.deptId )
                var point = new BMapGL.Point(e.lng, e.lat); 
                let opts = {
                    width:450,
                    height: 270,
                    // title: `<div ><span class="iconfont icon-jicengdangjian"></span>${ this.info.deptName }</div>`,
                    title: "党支部信息"
                }
                let innerHtml = `
                    <div style="font-size:19px;font-weight:bold;padding: 10px 0;"><span style="margin-right:10px;font-size:22px; color: rgb(252,214,44);" class="iconfont icon-jicengdangjian"></span>${ this.info.deptName }</div>
                    <div class="info_item" style="padding:5px;">党组织类别: ${ this.info.deptType }</div>
                    <div class="info_item" style="padding:5px;">党组织书记: ${ this.info.leaders }</div>
                    <div class="info_item" style="padding:5px;">联系电话: ${ this.info.phone }</div>
                    <div class="info_item" style="padding:5px;">单位地址: ${ this.info.address }</div>
                    <div id="enterBtn" style="width:120px;height:30px;text-align:center;margin:10px auto;cursor:pointer;background:#2767c4 ;color:#fff;line-height:30px;">
                        进入主页
                    </div>
                `
                this.infoWindow = new BMapGL.InfoWindow( innerHtml, opts); 
                this.map.openInfoWindow(this.infoWindow, point); //开启信息窗口
                    //判断窗口的打开状态
                    if (!this.infoWindow.isOpen()) {
                            //如果没有打开，则监听打开事件，获取按钮，添加事件
                        this.infoWindow.addEventListener("open", function () {
                            document.getElementById("enterBtn").onclick = function (e) {
                                // alert("需要跳转到党支部页面");
                                self.$store.commit("getDeptId", self.info.deptId)
                                localStorage.setItem("deptId", self.info.deptId)
                                localStorage.setItem("activeIndex", 0)
                                let urls = self.$router.push(`/ZuzhiInfo/${self.info.deptId}`)
                                // window.href( urls.href)
                            }
                        })
                    } else {//如果已经打开，直接获取按钮，添加事件
                        document.getElementById("enterBtn").onclick = function (e) {
                            // alert("获取btn");
                            self.$store.commit("getDeptId", self.info.deptId)
                            localStorage.setItem("deptId", self.info.deptId)
                            localStorage.setItem("activeIndex", 0)
                            let urls = self.$router.push(`/ZuzhiInfo/${self.info.deptId}`)
                            // window.open( urls.href,'_blank')
                        }
                    }
            },

            // 点击信息窗口按钮
            InfoClick () {
                console.log("1")
            },
            // 组织变化
            deptChange ( e ) {
                console.log( e )
                this.DeptList = []
                this.AllDeptList.forEach( (el, index) => {
                    if ( el.deptId == e ) {
                        this.DeptList.push( el )
                        this.activeIndex = index
                    }
                })
                
            },

            // 获取组织列表
            async getDeptList () {
                let res = await this.$axios.post("/lencon/pc/maps/dept_list")
                if ( res.data.code == 1 ) {
                    this.DeptList = res.data.data
                    this.AllDeptList = res.data.data
                    console.log( this.AllDeptList )
                }
            },

            // 获取所有组织的坐标信息
            async getMapPoint () {
                let res = await this.$axios.post("/lencon/pc/maps/dept_map_info")
                if ( res.data.code == 1 ) {
                    this.DeptList = res.data.data
                    this.AllDeptList = res.data.data
                }
            },
            // 获取单个组织信息
            async getDeptInfo ( deptId ) {
                let res = await this.$axios.post("/lencon/pc/maps/dept_info", { deptId })
                if ( res.data.code == 1 ) {
                    this.info = res.data.data
                }
            }
        },
        updated() {
            console.log("我更新了")
            this.InitMap()
            if ( this.DeptList.length == 1 ) {
                console.log( this.DeptList )
                this.clickMark( this.DeptList[0])
            }
        },
    }
</script>
<style>
.el-select-dropdown {
    z-index: 99999999999999 !important;
    position: relative;
    left: 0;
    top: 0;
}

 .selected {
    color: #2767c4  !important;
 }

</style>

<style lang="scss" scoped>
.active {
    color: #2767c4 ;
    font-weight: bold;
}
.map {
    width: 1900px;
    // height: 100%;
    box-sizing: border-box;
    position: fixed;
    left: 0;
    top: 0;
    
    // margin-top: -500px;
    background-color: #fff;
    z-index: 10000;
    position: relative;
    left: 0;
    top: 0;
    .fixed_container {
        width: 300px;
        // height: 700px;
        background-color: rgba(255,255,255,.8);
        position: fixed;
        left: 30px;
        top: 200px;
        z-index: 100;
        .el-input {
            flex: 1;
        }
        .search_box {
            width: 100%;
            display: flex;
            color: #fff;
            position: absolute;
            left: 0;
            top: -60px;
            .btn_search {
                width: 40px;
                height: 40px;
                background-color: #2767c4 ;
                line-height: 40px;
                text-align: center;
            }
        }
        .main_con {
            width: 100%;
            .fixed_title {
                text-align: center;
                padding: 20px 0;
                border-bottom: 1px solid #eee;
                font-size: 20px;
                font-weight: bold;
            }
            .dept_list_box {
                // text-align: center;
                .dept_item {
                    padding: 10px 0  10px 20px;
                    cursor: pointer;
                }
            }
        }
    }
    #container {
        width: 100%;
        background-color: #fff;
    }
    // .mark_info {
    //     width: 450px;
    //     height: 270px;
    //     background: #FFFFFF;
    //     box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
    //     border-radius: 5px;
    //     position: absolute;
    //     z-index: 1000000;
    //     &::after {
    //         content: "";
    //         width:0;
    //         height: 0;
    //         border-width: 40px;
    //         border-style: solid;
    //         border-color:  #fff transparent transparent ;
    //         position: absolute;
    //         left: 50%;
    //         bottom: -80px;
    //         margin-left: -40px;
            
    //     }
    // }
    .map_header {
        width:100%;
        height: 60px;
        padding: 0 40px;
        position: absolute;
        left: 0;
        top: 0px;
        background-color: #fff;
        z-index: 100000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
            font-size: 26px;
            color: #2767c4 ;
            font-weight: bold;
            .iconfont {
                font-size: 30px;
                margin-right: 20px;
            }
        }
        .right {
            .el-button {
                margin:  0 20px;
            }
        }
    }
}
</style>